import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=33c4e26d&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=33c4e26d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4e26d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c4e26d')) {
      api.createRecord('33c4e26d', component.options)
    } else {
      api.reload('33c4e26d', component.options)
    }
    module.hot.accept("./MainMenu.vue?vue&type=template&id=33c4e26d&scoped=true", function () {
      api.rerender('33c4e26d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/layout/components/MainMenu.vue"
export default component.exports